import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";
import { useSwipeable } from "react-swipeable";
import { useNavigate } from "react-router-dom";


/* ================= Notification Item ================= */

function NotificationItem({ n, onOpen, onRemove }) {

 const handlers = useSwipeable({

  onSwipedLeft: () => onRemove(n.id),

  onSwipedRight: () => onRemove(n.id),

  trackMouse: true,

  preventScrollOnSwipe: true,

  delta: 60,

});


  return (

    <div

      {...handlers}

      onClick={() => onOpen(n)}

      style={{

        padding: 14,

        marginBottom: 10,

        borderRadius: 8,

        background: n.is_read ? "#f5f5f5" : "#e8f1ff",

        cursor: n.link ? "pointer" : "default",

        border: "1px solid #ddd"

      }}

    >



<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }}
>
  <strong>{n.title}</strong>

  {!n.is_read && (
    <div
      style={{
        width: 10,
        height: 10,
        borderRadius: "50%",
        background: "#2563eb"
      }}
    />
  )}
</div>



      

      <p style={{ margin: "6px 0" }}>{n.message}</p>

      {/* Show button if checkout link available */}
      {n.link && n.link.trim() !== "" && (
       <button
  onClick={(e) => {
    e.stopPropagation();
    onOpen(n);
  }}

  style={{
    background: "#2563eb",
    color: "white",
    border: "none",
    padding: "5px 10px",
    borderRadius: 5,
    cursor: "pointer",
    marginTop: 5
  }}
>

{n.order_type === "cod"
  ? "Check Delivery Charges →"
  : "Pay Now →"}

</button>
      )}


      <br />

      <small style={{ color: "gray" }}>

        {new Date(n.created_at).toLocaleString()}

      </small>

    </div>

  );

}



/* ================= Main Page ================= */

export default function NotificationsPage() {


  const [list, setList] = useState([]);

  const navigate = useNavigate();



  /* ================= Load Notifications ================= */

  useEffect(() => {

    axios

      .get("/notifications/")

      .then((res) => setList(res.data))

      .catch((err) => console.error(err));

  }, []);




  /* ================= Open Notification ================= */

  const openNotification = async (n) => {

    try {

      await axios.post(`/notifications/${n.id}/read/`);


      // update UI read status instantly

      setList(prev =>

        prev.map(item =>

          item.id === n.id

            ? { ...item, is_read: true }

            : item

        )

      );


      // Navigate if link present

      if (n.link && n.link.trim() !== "") {

        navigate(n.link, { state: { notificationId: n.id } });

      }


    } catch (err) {

      console.error(err);

    }

  };




  /* ================= Delete Notification ================= */

  const removeNotification = async (id) => {

    // remove from UI

    setList(prev => prev.filter(n => n.id !== id));


    try {

      await axios.delete(`/notifications/${id}/`);

    }

    catch (e) {

      console.log("Delete failed:", e);

    }

  };





  /* ================= UI ================= */

  return (

    <div style={{ padding: 20, maxWidth: 600, margin: "auto" }}>

      <h2>🔔 Notifications</h2>
<p
        style={{
          color: "#6b7280",
          fontSize: 13,
          marginBottom: 20,
        }}
      >
        Swipe left or right to delete notifications
      </p>

      {list.length === 0 && (

        <div
  style={{
    textAlign: "center",
    marginTop: 60,
    color: "#6b7280"
  }}
>
  <div style={{ fontSize: 50 }}>🔔</div>

  <p>No notifications yet</p>
</div>

      )}


      {list.map((n) => (

        <NotificationItem

          key={n.id}

          n={n}

          onOpen={openNotification}

          onRemove={removeNotification}

        />

      ))}


    </div>

  );

}
